import type { UseMutationResult } from 'react-query';
import { useMutation } from 'react-query';

import type { IAppRegion } from '~/lib/appSettings';
import type {
  IApiChangePasswordRequestBody,
  IApiChangePasswordResponseBody,
} from '../AuthApi.types';
import { useApi } from '~/lib/api/useApi';

export type IUseChangePasswordMutationValues = {
  region: IAppRegion;
  body: IApiChangePasswordRequestBody;
};

export const useChangePasswordMutation = (): UseMutationResult<
  IApiChangePasswordResponseBody,
  unknown,
  IUseChangePasswordMutationValues
> => {
  const api = useApi();

  return useMutation({
    mutationFn: (values: IUseChangePasswordMutationValues) =>
      api.auth.changePassword(values.region, values.body),
  });
};
